import api from '@/apis/di/payrollItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
// Combo grid Loại cán bộ khấu trừ
export const usePayrollDeductItemGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();
  const { proxy } = getCurrentInstance();
  // func call api lấy dữ liệu combo
  const onPayrollDeductItemComboboxLoadData = (payload, row, column) => {
    payload.sort = 'payroll_item_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    let extendRegular = [{ Field: 'payroll_item_type', Value: 3 }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.filter = extendFilter(payload.filter, extendRegular);
    payload.columns = payload.columns + ',column_data_type';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const payrollDeductItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã khoản lương',
        dataField: 'payroll_item_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản lương',
        dataField: 'payroll_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'payroll_item_name',
    valueField: 'payroll_item_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onPayrollDeductItemComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return { payrollDeductItemComboConfig, onPayrollDeductItemComboboxLoadData }; // trả về thêm để dùng chung cho cả combo không thuộc grid
};
